export const defaults = {
  'crm-table-pro': {
    group: 'PIPE_STATUS' as 'PIPE_STATUS' | 'EMPLOYEE',
    size: 'small' as 'small' | 'middle' | 'large',
    columns: [
      { name: '№', width: 60, id: '1', checked: true },
      { name: 'Lid_nomi', translateKey: 'home', width: 280, id: '2', checked: true },
      { name: 'Kontakt_nomi', translateKey: 'one_lid', width: 224, id: '3', checked: true },
      { name: 'Masul_xodim', translateKey: 'triggers', width: 250, id: '4', checked: true },
      { name: 'Teg', width: 100, id: '5', checked: true },
      { name: 'Sana', translateKey: 'home', width: 223, id: '6', checked: true },
      { name: 'Balans', translateKey: 'home', width: 234, id: '7', checked: true }
    ] as {
      name: string;
      translateKey?: string;
      id?: string;
      fieldId?: number | null;
      checked: boolean;
      width: number;
    }[]
  }
};

export type Defaults = typeof defaults;
export type Keys = keyof Defaults;
